import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 4rem;
  background: rgba(0,0,0,.65);
  color: #fff;
  padding: .6rem 1.2rem;
  border-radius: .6rem;
  font-weight: 600;
`;

export const TeamBox = styled.div`
  display: flex;
  align-items: center;
  gap: .6rem;
  .score {
    font-size: 1.8rem;
  }
`;
